import { styled } from "@mui/material/styles";

export const Component = styled("div", {
  label: "label",
})`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;
`;
